export type SkeletonVariant = "text" | "avatar" | "block";

const VARIANT_CLASSES: Record<SkeletonVariant, string> = {
  text: "rounded-sm",
  avatar: "rounded-full",
  block: "rounded-lg",
};

export interface SkeletonProps {
  variant?: SkeletonVariant;

  className: string;
}

export function Skeleton({ variant = "text", className }: Readonly<SkeletonProps>) {
  return (
    <div
      aria-hidden="true"
      className={["animate-pulse bg-surface-secondary", VARIANT_CLASSES[variant], className].join(" ")}
    />
  );
}
